import React from 'react';
import { Send, Settings, Package, ArrowRight } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';

const ProcessOverview = () => {
  const steps = [
    {
      number: '01',
      icon: Send,
      title: 'Send Sample',
      description: 'Ship your biomass or waste material sample to our facility',
      color: 'from-blue-600 to-blue-700'
    },
    {
      number: '02',
      icon: Settings,
      title: 'Choose Temperature & Time',
      description: 'Specify your required temperature (1,000-2,000°C) and duration (10-60s)',
      color: 'from-green-600 to-green-700'
    },
    {
      number: '03',
      icon: Package,
      title: 'Receive Treated Material',
      description: 'Done – Get your research-ready, high-novelty materials with enhanced performance, ready for pick-up',
      color: 'from-blue-600 to-green-600'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            What We DO for YOU
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Simple, fast, and precise thermal treatment process for your materials
          </p>
        </div>

        {/* Process Steps */}
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8 relative">
            {steps.map((step, index) => {
              const Icon = step.icon;
              return (
                <div key={index} className="relative">
                  {/* Arrow between cards (desktop only) */}
                  {index < steps.length - 1 && (
                    <div className="hidden md:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                      <ArrowRight className="w-8 h-8 text-green-600" />
                    </div>
                  )}
                  
                  <Card className="border-2 hover:border-green-600 transition-all duration-300 hover:shadow-2xl h-full">
                    <CardHeader>
                      {/* Step Number */}
                      <div className="flex items-center justify-between mb-4">
                        <span className="text-6xl font-bold text-gray-200">{step.number}</span>
                        <div className={`w-16 h-16 bg-gradient-to-br ${step.color} rounded-xl flex items-center justify-center`}>
                          <Icon className="w-8 h-8 text-white" />
                        </div>
                      </div>
                      
                      <CardTitle className="text-2xl mb-3">{step.title}</CardTitle>
                    </CardHeader>
                    <CardContent>
                      <p className="text-gray-600 text-base leading-relaxed">
                        {step.description}
                      </p>
                    </CardContent>
                  </Card>
                </div>
              );
            })}
          </div>

          {/* Additional Info Banner */}
          <div className="mt-12 bg-gradient-to-r from-green-600 to-blue-600 rounded-2xl p-8 text-white text-center">
            <h3 className="text-2xl font-bold mb-3">
              Advanced Rapid Thermal Treatment Technology for Research-Grade Materials
            </h3>
            <p className="text-lg text-white/90 max-w-3xl mx-auto">
              Our advanced rapid thermal treatment technology ensures consistent, research-ready results every time. 
              Choose your exact specifications and receive professionally processed materials.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessOverview;
